import React from "react";
import { Outlet } from "react-router-dom";
const ReportIndex = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default ReportIndex;
